import {createRouter, createWebHashHistory} from 'vue-router'
import pageView from '@/layout/pageView'
import pageLayout from '@/layout/pageLayout'

const routes = [
    {
        path: '/',
        meta: {title: '首页'},
        redirect: '/index',
        component: pageLayout,
        children: [
            {
                name: 'index',
                meta: {title: '首页', sel: '/index'},
                path: '/index',
                component: () => import('@/views/index')
            },
            {
                name: 'userInfo',
                meta: {title: '个人信息'},
                path: '/userInfo',
                component: () => import('@/views/userInfo')
            },
        ]
    },
    {
        path: '/statistics',
        meta: {title: '统计中心'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'statisticsScreen',
                meta: {title: '数字大屏', sel: '/statistics/screen'},
                path: '/statistics/screen',
                component: () => import('@/views/largeScreen')
            },
        ]
    },
    {
        path: '/account',
        meta: {title: '账号管理'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'merchantAccount',
                meta: {title: '商家账号', sel: '/account/merchant/list'},
                path: '/account/merchant/list',
                component: () => import('@/views/merchantAccount')
            },
            {
                name: 'merchantAdd',
                meta: {title: '新增商家账号', sel: '/account/merchant/list'},
                path: '/account/merchant/merchantAdd',
                component: () => import('@/views/merchantAdd')
            },
            {
                name: 'merchantEdit',
                meta: {title: '编辑商家账号', sel: '/account/merchant/list'},
                path: '/account/merchant/merchantEdit',
                component: () => import('@/views/merchantAdd')
            },
            {
                name: 'siteAuthorize',
                meta: {title: '站点授权', sel: '/account/merchant/list'},
                path: '/account/site/authorize',
                component: () => import('@/views/siteAuthorize')
            },
            {
                name: 'staffManage',
                meta: {title: '员工管理', sel: '/account/staff/list'},
                path: '/account/staff/list',
                component: () => import('@/views/staffManage')
            },
            {
                name: 'staffAdd',
                meta: {title: '添加员工', sel: '/account/staff/list'},
                path: '/account/staff/add',
                component: () => import('@/views/staffAdd')
            },
            {
                name: 'staffEdit',
                meta: {title: '编辑员工', sel: '/account/staff/list'},
                path: '/account/staff/edit',
                component: () => import('@/views/staffAdd')
            },
            {
                name: 'roleManage',
                meta: {title: '角色管理', sel: '/account/role/list'},
                path: '/account/role/list',
                component: () => import('@/views/roleManage')
            },

        ]
    },
    {
        path: '/customer',
        meta: {title: '客户管理'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'customerList',
                meta: {title: '客户列表', sel: '/customer/customerManage/list'},
                path: '/customer/customerManage/list',
                component: () => import('@/views/customerList')
            },
            {
                name: 'customerAdd',
                meta: {title: '新增客户', sel: '/customer/customerManage/list'},
                path: '/customer/customerManage/add',
                component: () => import('@/views/customerAdd')
            },
            {
                name: 'customerEdit',
                meta: {title: '编辑客户', sel: '/customer/customerManage/list'},
                path: '/customer/customerManage/edit',
                component: () => import('@/views/customerInfo/edit')
            },
            {
                name: 'customerDetail',
                meta: {title: '客户详情', sel: '/customer/customerManage/list'},
                path: '/customer/customerManage/detail',
                component: () => import('@/views/customerInfo/detail')
            },
        ]
    },
    {
        path: '/contract',
        meta: {title: '合同管理'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'contractList',
                meta: {title: '合同列表', sel: '/contract/contractManage/list'},
                path: '/contract/contractManage/list',
                component: () => import('@/views/contractList')
            },
            {
                name: 'contractAdd',
                meta: {title: '新增合同', sel: '/contract/contractManage/list'},
                path: '/contract/contractManage/add',
                component: () => import('@/views/contractAdd')
            },
            {
                name: 'contractEdit',
                meta: {title: '编辑合同', sel: '/contract/contractManage/list'},
                path: '/contract/contractManage/edit',
                component: () => import('@/views/contractInfo/edit')
            },
            {
                name: 'contractDetail',
                meta: {title: '合同详情', sel: '/contract/contractManage/list'},
                path: '/contract/contractManage/detail',
                component: () => import('@/views/contractInfo/detail')
            },
            {
                name: 'contractMain',
                meta: {title: '合同主体', sel: '/contract/contractManage/contractMain'},
                path: '/contract/contractManage/contractMain',
                component: () => import('@/views/contractMain')
            },
        ]
    },
    {
        path: '/authorize',
        meta: {title: '授权管理'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'authorizeList',
                meta: {title: '授权列表', sel: '/authorize/list'},
                path: '/authorize/list',
                component: () => import('@/views/authorize')
            },
        ]
    },
    {
        path: '/project',
        meta: {title: '项目管理'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'ledgerList',
                meta: {title: '项目台账', sel: '/project/ledger/list'},
                path: '/project/ledger/list',
                component: () => import('@/views/ledgerList')
            },
            {
                name: 'ledgerAdd',
                meta: {title: '项目台账新增', sel: '/project/ledger/list'},
                path: '/project/ledger/add',
                component: () => import('@/views/ledgerAdd')
            },
            {
                name: 'ledgerEdit',
                meta: {title: '项目台账编辑', sel: '/project/ledger/list'},
                path: '/project/ledger/edit',
                component: () => import('@/views/ledgerInfo/edit')
            },
            {
                name: 'ledgerDetail',
                meta: {title: '项目台账详情', sel: '/project/ledger/list'},
                path: '/project/ledger/detail',
                component: () => import('@/views/ledgerInfo/detail')
            },
        ]
    },
    {
        path: '/device',
        meta: {title: '设备管理'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'deviceEbike',
                meta: {title: '两轮桩设备台账', sel: '/device/ebike/list'},
                path: '/device/ebike/list',
                component: () => import('@/views/ebike')
            },
            {
                name: 'deviceEbikeDetail',
                meta: {title: '查看两轮桩设备台账', sel: '/device/ebike/list'},
                path: '/device/ebike/detail',
                component: () => import('@/views/ebikeDetail')
            },
            {
                name: 'deviceEbikeOffline',
                meta: {title: '两轮桩设备台账(离线)', sel: '/device/ebikeOffline/list'},
                path: '/device/ebikeOffline/list',
                component: () => import('@/views/ebikeOffline')
            },
            {
                name: 'deviceEbikeOfflineCreate',
                meta: {title: '新增两轮桩设备台账(离线)', sel: '/device/ebikeOffline/list'},
                path: '/device/ebikeOffline/create',
                component: () => import('@/views/ebikeOfflineCreate')
            },
            {
                name: 'deviceEbikeOfflineEdit',
                meta: {title: '编辑两轮桩设备台账(离线)', sel: '/device/ebikeOffline/list'},
                path: '/device/ebikeOffline/edit',
                component: () => import('@/views/ebikeOfflineCreate')
            },
            {
                name: 'deviceEbikeOfflineDetail',
                meta: {title: '查看两轮桩设备台账(离线)', sel: '/device/ebikeOffline/list'},
                path: '/device/ebikeOffline/detail',
                component: () => import('@/views/ebikeOfflineDetail')
            },
            {
                name: 'deviceRecharge',
                meta: {title: '充值机设备台账', sel: '/device/recharge/list'},
                path: '/device/recharge/list',
                component: () => import('@/views/recharge')
            },
            {
                name: 'deviceRechargeDetail',
                meta: {title: '查看充值机设备台账', sel: '/device/recharge/list'},
                path: '/device/recharge/detail',
                component: () => import('@/views/rechargeDetail')
            },
            {
                name: 'deviceStock',
                meta: {title: '设备库存', sel: '/device/stock'},
                path: '/device/stock',
                component: () => import('@/views/stock')
            },
            {
                name: 'deviceScrap',
                meta: {title: '返厂注销', sel: '/device/scrap'},
                path: '/device/scrap',
                component: () => import('@/views/scrap')
            },
        ]
    },
    {
        path: '/order',
        meta: {title: '订单管理'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'order',
                meta: {title: '订单查询', sel: '/order/detail'},
                path: '/order/detail',
                component: () => import('@/views/orderDetail')
            },
            {
                name: 'twoWheelpile',
                meta: {title: '两轮桩订单', sel: '/order/twoWheelpile'},
                path: '/order/twoWheelpile',
                component: () => import('@/views/order/twoWheelpile')
            },
            {
                name: 'twoWheelpileDetail',
                meta: {title: '两轮桩订单详情', sel: '/order/twoWheelpile'},
                path: '/order/twoWheelpile/detail',
                component: () => import('@/views/order/twoWheelpile/detail')
            },
            {
                name: 'carWheelpile',
                meta: {title: '汽车桩订单', sel: '/order/carWheelpile'},
                path: '/order/carWheelpile',
                component: () => import('@/views/order/carWheelpile')
            },
            {
                name: 'carWheelpileDetail',
                meta: {title: '汽车桩订单详情', sel: '/order/carWheelpile'},
                path: '/order/carWheelpile/detail',
                component: () => import('@/views/order/carWheelpile/detail')
            },
        ]
    },
    {
        path: '/report',
        meta: {title: '报表中心'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'revenue',
                meta: {title: '站点营收', sel: '/report/revenue'},
                path: '/report/revenue',
                component: () => import('@/views/revenue')
            },
        ]
    },
    {
        path: '/export',
        meta: {title: '导出管理'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'exportList',
                meta: {title: '导出管理', sel: '/export/list'},
                path: '/export/list',
                component: () => import('@/views/export')
            },
        ]
    },
    {
        path: '/system',
        meta: {title: '系统设置'},
        redirect: '/404',
        component: pageLayout,
        children: [
            {
                name: 'menuList',
                meta: {title: '菜单管理', sel: '/system/menu/list'},
                path: '/system/menu/list',
                component: () => import('@/views/menu')
            },
            {
                name: 'authList',
                meta: {title: '权限管理', sel: '/system/auth/list'},
                path: '/system/auth/list',
                component: () => import('@/views/auth')
            },
            {
                name: 'areaList',
                meta: {title: '区域配置', sel: '/system/area/list'},
                path: '/system/area/list',
                component: () => import('@/views/area')
            },
            {
                name: 'logList',
                meta: {title: '日志管理', sel: '/system/log/list'},
                path: '/system/log/list',
                component: () => import('@/views/log')
            },
        ]
    },
    {
        name: 'login',
        meta: {title: '登录'},
        path: '/login',
        component: () => import('@/views/login')
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/components/exception/404'),
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/404',
    },
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

export default router
